import React from 'react';
import TeamPanel from './TeamPanel';

const PlayersManager = ({ 
  squadra1, 
  squadra2, 
  giocatoriSquadra1, 
  giocatoriSquadra2,
  falli1,
  falli2, 
  fairPlay1,
  fairPlay2,
  tipoPartita,
  onUpdateGiocatore, 
  onToggleCartellino,
  onUpdateFalli1,
  onUpdateFalli2,
  onUpdateFairPlay1,
  onUpdateFairPlay2
}) => {
  return (
    <div className="match-squadre-gestione">
      {/* Squadra 1 */}
      <TeamPanel
        squadra={squadra1}
        giocatori={giocatoriSquadra1}
        falli={falli1}
        fairPlay={fairPlay1}
        onUpdateGiocatore={onUpdateGiocatore}
        onToggleCartellino={onToggleCartellino}
        onUpdateFalli={onUpdateFalli1}
        onUpdateFairPlay={onUpdateFairPlay1}
        teamNumber={1}
        giocatoriSquadra1={giocatoriSquadra1}
        giocatoriSquadra2={giocatoriSquadra2}
        falli1={falli1}
        falli2={falli2}
        tipoPartita={tipoPartita}
      />

      {/* Squadra 2 */}
      <TeamPanel
        squadra={squadra2}
        giocatori={giocatoriSquadra2}
        falli={falli2}
        fairPlay={fairPlay2}
        onUpdateGiocatore={onUpdateGiocatore}
        onToggleCartellino={onToggleCartellino}
        onUpdateFalli={onUpdateFalli2}
        onUpdateFairPlay={onUpdateFairPlay2}
        teamNumber={2}
        giocatoriSquadra1={giocatoriSquadra1}
        giocatoriSquadra2={giocatoriSquadra2}
        falli1={falli1}
        falli2={falli2}
        tipoPartita={tipoPartita}
      />
    </div>
  );
};

export default PlayersManager;